import { type ReactElement } from 'react';
import cx from 'clsx';
import { Dialog, type DialogProps, Popover, type PopoverProps } from 'react-aria-components';
import styles from './dialog-content.module.css';

export interface DialogContentProps extends DialogProps {
  placement?: PopoverProps['placement'];
  popoverClassName?: string;
}

export function DialogContent({
  className,
  popoverClassName,
  placement = 'bottom start',
  ...props
}: DialogContentProps): ReactElement {
  // react-aria modal escapes the test container, we render it where it can find the modal (i.e. <div> component with 'ember-testing' id)
  const TEST_PORTAL_CONTAINER = document.getElementById('ember-testing') ?? undefined;

  return (
    <Popover
      UNSTABLE_portalContainer={TEST_PORTAL_CONTAINER}
      className={cx(styles.popover, popoverClassName)}
      offset={8}
      placement={placement}
    >
      <Dialog className={cx(styles.dialog, className)} {...props} />
    </Popover>
  );
}
